import { useCallback } from 'react';

import { RecurrenceInboxEntry } from '@this+that/models';
import log from 'loglevel';

import { useGetRecurrenceInboxEntryByReferenceId as useGetByReferenceIdService } from '../../services/recurrenceInboxEntries.service';

interface UseGetRecurrenceInboxEntryByReferenceIdReturn {
  getRecurrenceInboxEntryByReferenceId: (
    referenceInboxEntryId: string,
  ) => Promise<RecurrenceInboxEntry | null>;
  isFetching: boolean;
}

export function useGetRecurrenceInboxEntryByReferenceId(): UseGetRecurrenceInboxEntryByReferenceIdReturn {
  const {
    getRecurrenceInboxEntryByReferenceId: getByReferenceIdService,
    loading: isFetching,
  } = useGetByReferenceIdService();

  const getRecurrenceInboxEntryByReferenceId = useCallback(
    async (
      referenceInboxEntryId: string,
    ): Promise<RecurrenceInboxEntry | null> => {
      try {
        return await getByReferenceIdService(referenceInboxEntryId);
      } catch (error) {
        log.error(
          'useGetRecurrenceInboxEntryByReferenceId: failed to fetch recurrence by reference id:',
          error,
        );
        return null;
      }
    },
    [getByReferenceIdService],
  );

  return { getRecurrenceInboxEntryByReferenceId, isFetching };
}
